import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=2f8c1c8a&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=2f8c1c8a&prod&lang=scss"
import style1 from "./AppMain.vue?vue&type=style&index=1&id=2f8c1c8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8c1c8a",
  null
  
)

export default component.exports